import * as yup from 'yup';

const max = 60;

export const validacaoFormImagens = yup.object().shape({
    nome: yup
        .string()
        .nullable()
        .max(max, 'O nome do aparelho deve ter no máximo 60 caracteres.')
        .required('Campo nome é obrigatório')    
         
});
